import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import axios, { type AxiosError, type AxiosRequestConfig, type Method } from 'axios';
import client from '../api/client';
import { getApiErrorMessage } from '../lib/api-error';
import type { ApiRequestMeta } from './requestMeta';

export type AxiosBaseQueryArgs = {
  url: string;
  method?: Method;
  data?: unknown;
  params?: Record<string, unknown>;
  meta?: ApiRequestMeta;
};

export type AxiosBaseQueryError = {
  status?: number;
  data?: unknown;
  message: string;
};

export const axiosBaseQuery =
  (): BaseQueryFn<AxiosBaseQueryArgs, unknown, AxiosBaseQueryError> =>
  async ({ url, method = 'GET', data, params, meta }) => {
    const config: AxiosRequestConfig = {
      url,
      method,
      data,
      params,
      background: meta?.background,
      skipGlobalErrorToast: meta?.skipGlobalErrorToast,
      skipCache: meta?.skipCache,
      timeout: meta?.timeout,
    };

    try {
      const result = await client(config);
      return { data: result.data };
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        return {
          error: {
            status: axiosError.response?.status,
            data: axiosError.response?.data,
            message: getApiErrorMessage(axiosError),
          },
        };
      }
      return {
        error: {
          message: getApiErrorMessage(error),
        },
      };
    }
  };
